import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { pathOr } from "ramda";
import { formatCurrency } from "../helpers/formatter";
import { useDispatch } from "react-redux";
import { shareCrmLink } from "../redux/actions/policyAction";

const LoanCard = (props) => {
    const { policy } = props
    const user = pathOr(false, ['user'], props)
    const dispatch = useDispatch();
    const shareLink = () => {
        dispatch(shareCrmLink({ policyNumber: policy.policyNumber }))
    }
    return (
        <div style={{ borderRadius: 16, borderWidth: 1, borderColor: '#489135', background: '#EDF6EB', marginTop: 12, borderStyle: 'solid', }}>
            <Grid container columns={{ xs: 4, sm: 8, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', padding: 30 }}>
                <Grid size={5} spacing={2}>
                    <div>
                        <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                            <Typography>Loan On Insurance </Typography>
                        </div>
                        <Typography variant='caption'>Get a loan on savings insurance
                            policy in 3 minutes </Typography>
                    </div>
                </Grid>
                <Grid spacing={2}>
                    <div>
                        <Typography color='#40812F' variant='h5' align='center'>₹ {formatCurrency(pathOr(0, ['loanInfo', 'eligibleLoanOnInsuranceAmount'], policy))}</Typography>
                        <Typography align='center' variant='body2'>Loan amount</Typography>
                    </div>
                </Grid>
                {user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success'>Avail Now</Button>
                        </div>
                    </Grid>
                )}
                {!user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success' onClick={() => shareLink()}>Share Link</Button>
                        </div>
                    </Grid>
                )}
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: 'white', margin: 0 }}>
                <Grid size={6} spacing={2}>
                    <Grid container className='rateofDiv'>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Rate of Interest</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">{pathOr(0, ['loanInfo', 'loanInterest'], policy)} %</Typography></Grid>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Processing Fee</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'loanProcessingFee'], policy))}</Typography></Grid>
                    </Grid>
                </Grid>
                <Grid size={6} spacing={2} style={{}}>
                    <Grid container className='rateofDiv' style={{ backgroundColor: '#f5f5f5', margin: '10px' }}>
                        <Grid size={6} spacing={2}>
                            <Typography align='center' variant="caption" style={{ paddingLeft: 12 }}>EMI Tenure</Typography>
                        </Grid>

                        <Grid size={6} align='center' spacing={2}><Typography variant="caption" style={{ paddingRight: 12 }}>EMI Amount</Typography></Grid>

                        {
                            (pathOr([], ['loanInfo', 'loanOnInsuranceEmi'], policy)).map((data, index) => {
                                if (index < 3) {
                                    return (
                                        <>
                                            <Grid size={6} spacing={2}>
                                                <Typography align='center' style={{ paddingLeft: 12 }} variant="caption">{JSON.stringify(index + 1)} Year</Typography>
                                            </Grid>
                                            <Grid size={6} align='center' spacing={2}><Typography variant="caption" style={{ paddingRight: 12 }}>₹ {formatCurrency(data[index + 1].emi)}</Typography></Grid>
                                        </>
                                    )
                                }
                            })
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: '#204018', margin: 0, paddingTop: 30, paddingBottom: 30, paddingLeft: 12, paddingRight: 12, borderRadius: '0 0 16px 16px' }}>
                <Grid spacing={2}>
                    <div>
                        <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                            <Typography>Overdraft Facility</Typography>
                        </div>
                    </div>
                </Grid>
                <Grid spacing={2}>
                    <div>
                        <Typography color='#FFF' variant='h5' align='center'>₹  {formatCurrency(pathOr(0, ['loanInfo', 'eligibleLoanOnInsuranceAmount'], policy))}</Typography>
                        <Typography color='#FFF' align='center' variant='body2'>Loan amount</Typography>
                    </div>
                </Grid>

                <Grid size={6} spacing={2}>
                    <Grid container style={{}}>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Rate of Interest</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption" color="white">{pathOr(0, ['loanInfo', 'loanInterest'], policy)} %</Typography></Grid>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Processing Fee</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography color="white" variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'loanProcessingFee'], policy))}</Typography></Grid>
                    </Grid>

                </Grid>
                <Grid size={6} spacing={2}>
                    <Grid container style={{}}>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Upfront amount</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption" color="white">₹ {formatCurrency(pathOr(0, ['loanInfo', 'eligibleLoanOnInsuranceAmount'], policy) * 0.15)}</Typography></Grid>

                    </Grid>

                </Grid>
                <Grid size={12} spacing={2}>
                    <Typography color="#FAAD14" variant="caption">The upfront amount will be deducted, and the remaining loan amount will be credited to the bank account .</Typography>

                </Grid>

            </Grid>
        </div>
    )
}

export default LoanCard